import { Component, OnInit } from '@angular/core';
import { UiService } from 'projects/admin/src/app/services/ui.service';

@Component({
  selector: 'app-modal-spinner',
  templateUrl: './modal-spinner.component.html',
  styleUrls: ['./modal-spinner.component.scss']
})
export class ModalSpinnerComponent implements OnInit {

  constructor(
    public ui: UiService
  ) { }

  ngOnInit(): void {
  }

}
